import { useQuery } from "@apollo/client";
import { NavigationBar } from "components/base/base";
import Button from "components/base/Button";
import Errors from "components/base/Errors";
import Spinner from "components/base/Spinner";
import useAutoScrollToBottom from "hooks/useAutoScrollToBottom";
import { useModals } from "ModalProvider";
import { useParams, useSearchParams } from "react-router-dom";
import { FETCH_PRODUCT_SUPPLIER_STOCK } from "./graphql";
import ProductStocksTableView from "./ProductStocksTableView";
import SupplierStockDeliveryForm from "./SupplierStockDeliveryForm";

const ProductStock = () => {
  const { id } = useParams();
  const { loading, error, data } = useQuery(FETCH_PRODUCT_SUPPLIER_STOCK, {
    variables: { id },
  });
  const modal = useModals();
  const [searchParams] = useSearchParams({ filterSupplierId: "ALL" });
  const filterSupplierId = searchParams.get("filterSupplierId") || "ALL";
  const ref = useAutoScrollToBottom(data);

  if (loading) return <Spinner />;
  if (error) return <Errors error={error} />;

  const supplierStock = JSON.parse(data.supplierStock);

  console.log(
    "data.productSupplierStockReservations",
    data.productSupplierStockReservations,
  );

  const rows = supplierStock.map((i) => {
    const reservation = data.productSupplierStockReservations.find(
      (r) => r.plan.id === `${i.plan_id}`,
    );
    return { ...i, reservation };
  });

  function createStockDelivery() {
    let supplierId = null;
    const ss = supplierStock.filter((i) => i.type === "SS");
    if (ss.length > 0) {
      supplierId = ss[ss.length - 1].supplier_id;
    }
    modal.present({
      title: "Create Stock Delivery",
      children: (
        <SupplierStockDeliveryForm
          initData={{ supplierId, product: data.product }}
          complete={modal.hide}
        />
      ),
    });
  }

  return (
    <div className="flex flex-1 flex-col overflow-auto">
      <NavigationBar
        backTo={`./..?filterSupplierId=${filterSupplierId}`}
        title={`[${data.product.number}] ${data.product.name}`}
        rightButtons={
          <Button onClick={createStockDelivery}>+ Create Stock Delivery</Button>
        }
      />
      <div className="flex-1 overflow-auto whitespace-nowrap" ref={ref}>
        <ProductStocksTableView product={data.product} rows={rows} />
      </div>
    </div>
  );
};

export default ProductStock;
